import React from "react";

interface Props {
  src: string,
  alt: string,
  width: number,
  height: number,
  caption?: string,
}

const ArticleImage: React.FC<Props> = (
  {
    src,
    alt,
    width,
    height,
    caption = null,
  }
) => {
  return (
    <figure className="mb-4">
      <img
        className="mb-4 shadow-2xl shadow-[rgba(255,255,255,0.2)] aspect-video"
        decoding="async"
        width={width}
        height={height}
        src={src}
        alt={alt}
        title={caption ?? alt}
      />
      {caption ? <figcaption className="text-sm font-thin">{caption}</figcaption> : null}
    </figure>
  );
};

export default ArticleImage;